<template>
  <!-- 企業検診機器受領 -->
  <div id="KenshinDeviceReturn">
    <div id="container">
      <kenshinNavi v-bind:pageid='"KenshinDeviceReturn"'></kenshinNavi>
      <div class="kenshinLabelTitle lable">企業検診 機器受領</div>
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>シリアル番号</th>
            <td><input type="text" id="serialInput" v-model="serial" @keyup.enter="onKeyupEnter()"/></td>
          </tr>
        </table>
          <b-button class="addButton is-primary" @click="addDevice">追加</b-button>
      </div>
      <div class="result-area" v-if="data.length > 0">
        <div class="button-area">
          <span class="result-count">件数：{{data.length}}件</span>
        </div>
        <b-table
            id="deviceReceiptListTable"
            :data="data"
            default-sort="user.first_name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
            <template slot-scope="props">
              <b-table-column label="#" width="40" centered>{{props.index + 1}}</b-table-column>
              <b-table-column field="receiptNumber" label="受付番号" width="150" centered>
                <a @click="showDetail(props.row.applicationDetails)">{{props.row.receiptNumber}} <b-icon icon="vector-arrange-above" /></a>
              </b-table-column>
              <b-table-column field="serial" label="シリアル番号" width="130" centered >
                {{props.row.serial}}
              </b-table-column>
              <b-table-column field="leaseupDate" label="リースアップ日" width="120" centered >
                {{props.row.leaseupDate}}
              </b-table-column>
              <b-table-column field="model" label="機種" width="210">
                {{props.row.model | choiceFilter(kenshinDeviceList)}}
              </b-table-column>
              <b-table-column field="shippingDate" label="出荷日" width="100">
                {{props.row.shippingDate}}
              </b-table-column>
              <b-table-column field="companyName" label="企業名">
                {{props.row.companyName}}　{{props.row.officeName}}
              </b-table-column>
              <b-table-column field="patientName" label="患者名" width="150">
                {{props.row.patientName}}
              </b-table-column>
              <!-- 20230605　川越#161追加 -->
              <b-table-column field="kawagoeNote" label="川越受付備考" width="150" >
                <div style="color:red;">{{props.row.remarks}}</div>
                {{props.row.kawagoeNote}}
              </b-table-column>
              <b-table-column field="delete" label="削除" width="50" centered >
                <b-button class="clearButton" @click="clearDevice(props.index)" icon-left="eraser"></b-button>
              </b-table-column>
            </template>
        </b-table>
        <div class="button-area">
          <b-button class="receptionistButton is-primary" :disabled="!data.length" @click="deviceReceipt">機器受領</b-button>
        </div>
      </div>
    </div>
    <floatingModal name="detail-modal" modalClass="detail-modal" @close="closeDetail" title="" width="900" height="480" top="100px" right="100px">
      <kenshinRequestDetail :data="showDetailTargetData" />
    </floatingModal>
  </div>
</template>

<script>
import floatingModal from "@/components/mock/common/FloatingModal";
import KenshinRequestDetail from "@/components/mock/common/KenshinRequestDetail";
import naviBar from "@/components/mock/philips/kenshin/KenshinNaviBar";
import {choicesType} from "@/components/mock/base/const.js";

export default {
  name: "KenshinDeviceReturn",
  methods: {
    onKeyupEnter: function(){
      if (this.serial) {
        //シリアルを取得
        let serialItems = this.serial.split('/');
        if(serialItems.length == 2){
          //　"/"が含まれていたらそれ以降の文字に変更する
          this.serial = serialItems[1]
        }
        this.addDevice();
      }
      else {
        this.addDevice();
      }
    },
    onFocus: function(){
      document.getElementById("serialInput").focus()
    },
    addDevice: async function(){
      if(!this.serial){
          var messsge ="シリアル番号を入力してください。";
          this.$dialog.alert({
            title: '　',
            message: messsge,
          })
      } else {
        var targetSerial = this.data.find(val => val.serial == this.serial)
        if(targetSerial){
          var messsge ="シリアル番号:"+this.serial+" は既に機器受領リストに追加済みです。";
          this.$dialog.alert({
            title: '　',
            message: messsge,
          })
          return
        }
        var excuteApi = this.getKenshinReturnDevicePOST;
        var successCallBack = this.getKenshinReturnDevicePOSTSuccess;
        var errorCallBack = this.getKenshinReturnDevicePOSTError;
        // WebAPI Call
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      }
    },
    getKenshinReturnDevicePOST: function(client) {
      return client.apis.internalKenshin.getKenshinReturnDevicePOST({ 
        body: {
          serial:this.serial
        } 
      });
    },
    getKenshinReturnDevicePOSTSuccess: function(result) {
      var machineDetail = result.obj;
      console.log(machineDetail)
      this.data.push(machineDetail);
      if(this.isPastday(machineDetail.leaseupDate)){
        // リースアップ日を超えている場合は、警告メッセージ
        var messsge = machineDetail.leaseupDate + "にリースアップ日を超過している機器です。";
          this.$dialog.alert({
            title: '　',
            message: messsge
          })
      }else{
        if(this.isSoon(machineDetail.leaseupDate,2)){
          // リースアップ日が2ヶ月以内の場合近づいている場合は、警告メッセージ
          var messsge = machineDetail.leaseupDate + "にリースアップする機器です。";
          this.$dialog.alert({
            title: '　',
            message: messsge
          })
        }
      }
      this.$nextTick(() => {
        //DOMが更新された後に呼ばれるコールバック
        var element = document.getElementById("deviceReceiptListTable")
        if(element){
          var scrollElement= element.getElementsByClassName("table-wrapper")[0]
          scrollElement.scrollTop = scrollElement.scrollHeight;  //スクロールバーを一番下に移動する
      }
      })
      this.serial = ""
      this.onFocus();
    },
    getKenshinReturnDevicePOSTError: function(result) {
      // シリアルに一致する利用可能な機器が存在しない場合
      this.serial = ""
      this.showErrorMessage(result,this.onFocus());
    },
    clearDevice: function(index) {
      this.data.splice(index, 1);
    },
    deviceReceipt: function(){
      // 機器受領
      var excuteApi = this.setKenshinDeviceReceiptPOST;
      var successCallBack = this.setKenshinDeviceReceiptPOSTSuccess;
      var errorCallBack = this.setKenshinDeviceReceiptPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setKenshinDeviceReceiptPOST: function(client) {
      var obj = []
      for(var i=0; i < this.data.length; i++){
        obj.push({
          receiptNumber:this.data[i].receiptNumber
        })
      }
      return client.apis.internalKenshin.setKenshinDeviceReceiptPOST({
        body: obj
      });
    },
    setKenshinDeviceReceiptPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = []
      this.showSuccess(result);
    },
    setKenshinDeviceReceiptPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    showDetail: function(rowData) {
      this.showDetailTargetData = rowData
      this.$modal.show('detail-modal')
    },
    closeDetail: function(){
      this.$modal.hide('detail-modal')
    },
  },
  data() {
    var kenshinDeviceList = this.getChoiceList(choicesType.kenshinDevice, false);
    return {
      data : [],
      isPaginated : true,
      serial:null,
      showDetailTargetData:{},
      kenshinDeviceList
    };
  },
  filters: {
    choiceFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
    kenshinNavi: naviBar,
    floatingModal:floatingModal,
    kenshinRequestDetail:KenshinRequestDetail
  },
};
</script>
<style lang="scss" scoped>
.condition-area {
    display: flex;
}
.conditionTable {
  width: 400px;
}
.addButton {
    margin-left:20px;
}
.dataExtractButton {
    margin-left: auto;
    margin-right: 10px;
}
.result-area {
  margin-top: 20px;
}
a {
  text-decoration: underline;
}
.opration-area {
    height:50px;
    margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/kenshin/KenshinDeviceReturn.vue